module.exports = __webpack_public_path__ + "static/media/river1.6d2d7833.png";